// Core
import Vue from 'vue';
import App from '@/App';
import vuetify from '@/plugins/vuetify';
import router from '@/router';
import store from '@/store/store';
import VueCompositionApi from '@vue/composition-api';

// Plugins
import '@/plugins/axios';
import i18n from '@/i18n';

// Styles
import '@mdi/font/css/materialdesignicons.min.css';
import '@/assets/tailwind.css';
import '@/styles/app.scss';
import '@/styles/tables.css';

Vue.config.productionTip = false;

Vue.use(VueCompositionApi);

new Vue({
  i18n,
  vuetify,
  router,
  store,
  beforeCreate() {
    this.$store.commit('initialiseStore');
  },
  render: h => h(App),
}).$mount('#app');
